import { Config } from "../models/config";

export const configService = {
  getConfig: (): Config => new Config(),
};
